/** Shared defaults and slider bounds for logo placement tool settings. */
export const LOGO_PLACEMENT_DEFAULTS = {
  textureScale: 0.08,
  offsetX: 0,
  offsetY: 0,
  patchHalfSizeCm: 2.5,
  rotateDeg: 0,
  embossEnabled: true,
  embossDepthMm: 0.4,
  /** 0 = auto from patch size; 1–6 = fixed subdivision passes */
  maxSubdivideIterations: 0,
};

export const LOGO_EMBOSS_DEPTH_SLIDER = {
  min: 0,
  max: 2,
  step: 0.05,
};

export const LOGO_SUBDIVIDE_ITERATIONS_SLIDER = {
  min: 0,
  max: 6,
  step: 1,
};

export const LOGO_TEXTURE_SCALE_SLIDER = {
  min: 0.05,
  max: 0.2,
  step: 0.01,
};

export const LOGO_ROTATE_SLIDER = {
  min: -180,
  max: 180,
  step: 1,
};

/** Hard alpha cutoff for baked / embossed logo ink (sharp silhouette). */
export const LOGO_ALPHA_CUT = 0.5;

/** Target patch raster resolution along the long edge (Method C). */
export const LOGO_PATCH_RASTER_MIN_PX = 2048;

/** Cap raster size to avoid OOM on apply. */
export const LOGO_PATCH_RASTER_MAX_PX = 4096;

/** Supersample factor before downsample (2 = 4× samples per output texel). */
export const LOGO_RASTER_SUPERSAMPLE = 2;

/** Internal build cap per axis (width × supersample). */
export const LOGO_PATCH_RASTER_BUILD_MAX_PX = 8192;

/** Max midpoint subdivision passes in the logo patch. */
export const LOGO_MAX_SUBDIVIDE_ITERATIONS = 4;

/** When true, emboss uses flat height inside ink (less interior noise). */
export const LOGO_EMBOSS_BINARY = true;
